import globals from '../../common/globals';

export default {
  name: 'vx-live-agent-btn',
  components: {},
  props: {
    // Text and label from properties file
    i18n: {
      type: Object,
      required: true,
    },
    // Flag to enable/ disable the sticky live chat button on all pages - based on backoffice config
    allPageLiveChat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      liveAgentConfig: globals.thirdPartyApps.liveAgent,
      globals,
      showButtons: false,
      showChatTimes: false,
    };
  },
  computed: {

  },
  /* eslint-disable */
  created() {
    // Checking if chat is enabled in backoffice config
    if (this.allPageLiveChat) {
      liveagent.init(
        this.liveAgentConfig.endPoint,
        this.liveAgentConfig.orgId,
        this.liveAgentConfig.deploymentId,
      );
    }
  },
  async mounted() {
    if (this.allPageLiveChat) {
      const self = this;
      if (!window._laq) {
        window._laq = [];
      }
      window._laq.push(function () {
        liveagent.showWhenOnline(
          self.liveAgentConfig.buttonId,
          self.$refs.chatAllPageOnline,
        );
        liveagent.showWhenOffline(
          self.liveAgentConfig.buttonId,
          self.$refs.chatAllPageOffline,
        );
      });

      // Pre populating the fields in the chat window for logged in user
      if (this.globals.getIsLoggedIn()) {
        liveagent.addCustomDetail('UserFirstName', this.globals.userInfo.firstName);
        liveagent.addCustomDetail('UserLastName', this.globals.userInfo.lastName);
        liveagent.addCustomDetail('UserEmail', this.globals.userInfo.email);
        liveagent.addCustomDetail('UserCompany', this.globals.userInfo.unit);
        liveagent.addCustomDetail('UserPhone', this.globals.userInfo.contactNumber);
      }
    }
  },
  methods: {
    /**
     * Triggers the salesforce chat window
     * @param {*} event
     */
    triggerChat(event) {
      liveagent.startChat(this.liveAgentConfig.buttonId);
    },
    toggleChatTimes() {
      this.showChatTimes = !this.showChatTimes;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-live-agent-btn/vx-live-agent-btn.js